/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { Grid, Tooltip, Typography, Zoom } from '@mui/material'
import Accordion from 'components/Common/Accordion/Accordion'
import UploadFile from 'components/Common/ElementInForm/UploadFile/UploadFile';
import { AlertTitleTh, AxiosGet, AxiosPost, Extension, ResultAPI } from 'service/CommonFunction/TS_function';
import { BtnConfirm, BtnSearchOnTable } from 'components/Common/Button';
import { GridColumns } from '@mui/x-data-grid-pro';
import { DataGridMuiClient } from 'components/Common/Table/DataGridMuiClient';
import InputCustomLabel from 'components/Common/ElementInForm/InputCustomLabelFormItem';
import moment from 'moment';
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import { SwAlert } from 'components/Common/Alert/AlertForm';
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';

const CpnNote = (props) => {
    const {
        sVOCFormID,
        nStatusID,
        sMode,
        objPermission
    } = props;


    const { BlockUI, UnBlockUI } = FnBlock_UI();


    const [IsView, setIsView] = useState(sMode === "view" || objPermission?.Note?.isDisable == true)
    const [DataRowNote, setDataRowNote] = useState([] as any)       //List Note
    const [arrFileNote, setarrFileNote] = useState([] as any)
    //SnankBar
    const [IsOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [sSeveritySnackbar, setsSeveritySnackbar] = useState("success")
    const [sMessageSnackbar, setsMessageSnackbar] = useState(null) as any

    const onClearFileNote = useRef(null);

    const schemaNote = yup.object().shape({
        sNote: yupFormSchemas.string("โน้ต", { required: true }),
    });
    const formNote = useForm({
        resolver: yupResolver(schemaNote),
        mode: 'all',
        shouldFocusError: true,
    })

    useEffect(() => {
        if(sVOCFormID)
        {
            GetNoteVOC();
        }
    }, [sVOCFormID])
    

    const GetNoteVOC =()=>{
        BlockUI();
        AxiosGet(`VOC/GetNote`, { sVOCFormID: sVOCFormID }, (res) => {
            UnBlockUI();
            ResultAPI(res, null, async () => {
                setDataRowNote(res || [])
            })
        })
    }

    const onAddNote2Table = () => {
        let param = {
            "sVOCFormID": sVOCFormID,
            "objFormNote": [
                {
                    "sVOCFormID": sVOCFormID,
                    "nNoteID": null,
                    "sNote": formNote.getValues("sNote") ?? null,
                    "nCreateBy": null,
                    "dCreate": null,
                    "lstFile": arrFileNote || []
                }
            ]
        }
        let sMessage = "คุณต้องการที่จะบันทึกโน้ตใช่หรือไม่ ?"

        SwAlert.Confirm(AlertTitleTh.Confirm, sMessage, () => {
            BlockUI();
            AxiosPost(`VOC/SaveNote`, param, (res) => {
                UnBlockUI();
                ResultAPI(res, null, () => {
                    let sHTML = <><p>บันทึกโน้ตสำเร็จ</p></>
                    setIsOpenSnackbar(true);
                    setsMessageSnackbar(sHTML)
                    setsSeveritySnackbar("success")
                    formNote.setValue("sNote", null)
                    onClearFileNote.current(null)
                    setDataRowNote(res || [])
                })
            }, null, null)
        })

    }

    const GotoFilePath = (item) => {
        window.open(item.row?.sFileLink ?? "/");
    }

    const dataColumn: GridColumns = [
        {
            field: "nRow",
            headerName: "ที่",
            headerAlign: "center",
            flex: 1,
            editable: false,
            resizable: false,
            disableReorder: true,
            align: "center",
            sortable: false,
        },
        {
            field: "sNote",
            headerName: "โน้ต",
            headerAlign: "center",
            flex: 4,
            align: "left",
            resizable: false,
            disableReorder: true,
            minWidth: 100,
            sortable: false,
            renderCell: (item) => {
                let message = [] = (item.value + "").split('\n')
                let jsxElement = 
                <div style={{display:'flex',flexDirection:'column'}}>
                {message.length > 0 && item.value != null ? message.map((m,ind) => ( <p key={`note_${ind}`} style={{ margin: '0'}}>{m}</p>)) : null}
                </div>
                return (
                    <Tooltip title={jsxElement} TransitionComponent={Zoom} placement="top-start" >
                        <Typography component={"label"} style={{ wordBreak: 'break-word',height:'21px' }}>{jsxElement} </Typography>
                    </Tooltip>
                );
            },
        },
        {
            field: "sFileName",
            headerName: "เอกสารแนบ",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: false,
            disableReorder: true,
            minWidth: 100,
            sortable: false,
            renderCell: (item) => {
                if (item.value != null && item.value != "") {
                    return (
                        <>
                            <BtnSearchOnTable txt='ดู' onClick={() => { GotoFilePath(item) }} /> &nbsp;&nbsp;&nbsp;
                            <Typography component={"label"} style={{ wordBreak: 'break-word' }}>
                                {item.value}
                            </Typography>
                        </>
                    );
                }
                else {
                    return (<></>)
                }

            },
        },
        {
            field: "sCreate",
            headerName: "ผู้บันทึก",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: false,
            disableReorder: true,
            minWidth: 100,
            sortable: false,
        },
        {
            field: "dCreate",
            headerName: "วันที่บันทึก",
            headerAlign: "center",
            flex: 2,
            align: "center",
            resizable: false,
            disableReorder: true,
            minWidth: 100,
            sortable: false,
            renderCell: (item) => {
                let textdate = item.value != null ? moment(item.value).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : null;
                return (
                    <Typography component={"label"} style={{ textAlign: 'center' }}>{textdate} </Typography>
                );
            },
        },
    ];


    return (
        <>
            <FormProvider {...formNote}>

                <Accordion header={"โน้ต (ข้อมูลใช้ภายใน)"}>

                    <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start" style={{marginTop:'-20px'}}>
                        {
                            IsView ? null :
                                <>
                                    <Grid item xs={12} >
                                        <InputCustomLabel
                                            id="sNote"
                                            name="sNote"
                                            label="โน้ต"
                                            required={true}
                                            multiline={true}
                                            maxLength={1000}
                                            rows={4}
                                            fullWidth

                                        />
                                    </Grid>
                                    <Grid item xs={12} >
                                        <UploadFile
                                            id="sDocFileNote"
                                            keyID={2}
                                            sTitle={"เอกสารแนบ"}
                                            IsRequired={false}
                                            arrFile={arrFileNote || []}
                                            setarrFile={setarrFileNote}
                                            IsFolder={false}
                                            IsFile={true}
                                            IsMultiple={false}
                                            Extension={[...Extension.PDF, ...Extension.Image, ...Extension.Word, ...Extension.Excel, ...Extension.Other]}
                                            IsDrag={false}
                                            nLimitFile={10}
                                            sLimitFile={"MB"}
                                            onClearFile={onClearFileNote}
                                        />
                                    </Grid>
                                    <Grid item xs={12} >
                                        <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" >
                                            <Grid item>
                                                <BtnConfirm txt={"บันทึกโน้ต"} onClick={formNote.handleSubmit(() => { onAddNote2Table() })} />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </>
                        }
                        <Grid item xs={12} >
                            <DataGridMuiClient
                                isLoading={false}
                                rows={DataRowNote}
                                HiddenToolHead={true}
                                Columns={dataColumn}
                                backgroundHeaderCustom={"#004290"}
                                sxCustomHeader={{ color: '#ffffff' }}
                            />
                        </Grid>
                    </Grid>
                </Accordion>
            </FormProvider>
            <SnackbarCustom
                IsOpen={IsOpenSnackbar}
                Severity={sSeveritySnackbar}
                OnClose={() => { setIsOpenSnackbar(false) }}
                Message={sMessageSnackbar}
            />
        </>
    )
}

export default CpnNote